import React, { useState, useEffect } from "react";
import VisibilityApi from "../state/Visibility-api";
import { bookingsStore } from "../state/CommonState";

const ShipmentJourney = ({ props }) => {
  const [data, setData] = useState({ milestones: [], myactions: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await VisibilityApi.getShipmentJourney(props.bookingId);
        setData(response);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [props.bookingId]);

  if (loading) return <p>Loading Shipment Journey...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!data.milestones.length && !data.myactions.length) return <p>No data available</p>;
  const shipmentScope = props.shipmentScope

  const renderMilestone = (title, items) => (
    <div style={{ marginBottom: "20px" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "auto" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Milestone</th>
            <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Date</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            if (
              (item.key === 'por_to_pol_movement' &&
              props?.por &&
              props?.pol &&
              props.por === props.pol) ||
              ((item.key === 'pod_arrival' || item.key === 'gateout_to_fpod')&&
              props?.pod &&
              props?.fpod &&
              props.pod === props.fpod)
            ) {
              return null;
            }

            return (
              <tr key={index}>
                <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>{(item.label === 'Gate-in at Cargo Terminal' && (shipmentScope === 'Door-to-Port' || shipmentScope === 'Door-to-Door')) ? "Arrival @ Dispatch Airport" : item.label}</td>
                <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{item.date}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  );

  const renderMyactions = (title, items) => (
    <div style={{ marginBottom: "20px" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "auto" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Action</th>
            <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Initiated on</th>
            <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Current Status</th>
            <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Completed on</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => (
            <tr key={index}>
              <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>{item.actionName}</td>
              <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{item.createdOn}</td>
              <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{item.status === "PENDING" ? item.status + ' with ' + item.pendingWith : item.status}</td>
              <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{item.completedOn ? item.completedOn : "NA"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderVendor = (title, items) => {
    const filteredItems = items.filter(item =>
      !(item.vendorId === "N/A" && item.assignedTo === "N/A" && item.updatedBy === "N/A" && item.updatedAt === "N/A")
    );

    if (filteredItems.length === 0) return null;

    return (
      <div style={{ marginBottom: "20px" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "auto" }}>
          <thead>
            <tr>
              <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Activity Name</th>
              <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Vendor ID</th>
              <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>User Assigned</th>
              <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Updated By</th>
              <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Updated At</th>
            </tr>
          </thead>
          <tbody>
            {filteredItems.map((item, index) => (
              <tr key={index}>
                <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                  {item.activityName
                    .split(" ")
                    .map((word, index) =>
                      index === 0 && word.length <= 3
                        ? word.toUpperCase()
                        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                    )
                    .join(" ")}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{item.vendorId}</td>
                <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{item.assignedTo}</td>
                <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{item.updatedBy}</td>
                <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{item.updatedAt}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };


  return (
    <div style={{ overflowX: "auto", width: "100%" }}>
      {data.myactions.length > 0 && renderMyactions("Actions", data.myactions)}
      {data.milestones.length > 0 && renderMilestone("Milestones", data.milestones)}
      {data.vendor.length > 0 && renderVendor("Vendor", data.vendor)}
    </div>
  );
};

export default ShipmentJourney;
